import { CONFIG_KUNDE_FORM } from './kunde-form.config';
import { CONFIG_KUNDE_FORM_VALIDATION } from './kunde-form-validation.config';
import { CONFIG_KUNDE_FORM_LAYOUT } from './kunde-form-layout.config';

export const CONFIG_KUNDE_FORM_GLOBAL = {
  formConfig: CONFIG_KUNDE_FORM,
  formValidationConfig: CONFIG_KUNDE_FORM_VALIDATION,
  formLayoutConfig: CONFIG_KUNDE_FORM_LAYOUT
};
